import { useMutation } from '@tanstack/react-query'

import { stockImportsApi } from '../api/stockImportsApi'
import {
  toMissingSkuExportParams,
  toMissingSkuExportRows,
} from '../lib/stockImportsMissingSku'
import type { MissingSkuQueryParams } from '../types/stockImports.types'

const MISSING_SKU_SHEET_NAME = 'Missing SKU'

export const useExportMissingSkuMutation = () =>
  useMutation({
    mutationFn: async ({
      logId,
      params,
    }: {
      logId: string
      params: MissingSkuQueryParams
    }) => {
      const items = await stockImportsApi.getAllMissingSku(
        logId,
        toMissingSkuExportParams(params)
      )
      const { utils, writeFile } = await import('xlsx')
      const workbook = utils.book_new()
      utils.book_append_sheet(
        workbook,
        utils.json_to_sheet(toMissingSkuExportRows(items)),
        MISSING_SKU_SHEET_NAME
      )
      writeFile(workbook, `missing-sku-${logId}.xlsx`)
      return items.length
    },
  })
